import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NCConversionPage } from '../pages/NCConversionPage';
import { DrawingConversionPage } from '../pages/DrawingConversionPage';
import { SettingsPage } from '../pages/SettingsPage';

/**
 * ルーティング設定コンポーネント
 * アプリケーションのルーティングを管理する
 */
export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* ルート設定 */}
      {/* NC変換ページへのルート */}
      <Route path="/nc-conversion" element={<NCConversionPage />} />
      {/* 図面変換ページへのルート */}
      <Route path="/drawing-conversion" element={<DrawingConversionPage />} />
      {/* 設定ページへのルート */}
      <Route path="/settings" element={<SettingsPage />} />
      {/* デフォルトルート設定 */}
      <Route path="/" element={<Navigate to="/nc-conversion" replace />} />
    </Routes>
  );
};